module.exports = __webpack_public_path__ + "static/icon-2-12a8956f7787de4906c528fd6baff31e.png";